/**
 * hình thức hóa đơn
 */
export default {
  Transfer: 0, // Chuyển khoản
  CashKB: 2, // Tiền mặt tại kho bạc
  CaskNH: 3, // Tiền mặt tại ngân hàng
};
